module.exports = __webpack_public_path__ + "img/download-bg.fdb6e577.png";